module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swap-vehicle-asset"
  }, [_c('a', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.swapEnabled = !_vm.swapEnabled
      }
    }
  }, [_vm._v("Swap")]), (_vm.swapEnabled) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.swapEnabled = false
      }
    }
  }, [_vm._v("x")]), _c('h2', [_vm._v("VS" + _vm._s(_vm.item.id))]), _c('p', [_vm._v("Select the destination from the dropdown list")]), _c('selectize-vehicle-slot', {
    on: {
      "optionSelected": _vm.selected
    }
  }), _c('button', {
    staticClass: "button",
    class: {
      disabled: !_vm.itemSelected
    },
    on: {
      "click": _vm.processSwap
    }
  }, [_vm._v("Confirm")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fb7d2ac!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/SwapAsset.vue
// module id = 2266
// module chunks = 1